module.exports = __webpack_public_path__ + "/images/logo-fr-kiavi.cc8ee42.svg";